import { render } from "./carousel-text.vue?vue&type=template&id=77b3d56e"
import script from "./carousel-text.vue?vue&type=script&lang=js"
export * from "./carousel-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__